import React, { useCallback } from 'react'
import { useParams } from 'react-router-dom'

import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import { useApiQuery } from 'admin/lib/Api'
import { EditAccount } from './EditAccount'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import styled from 'styled-components'
import { GetPageNames } from 'admin/lib/GetPageNames'
import * as ROUTES from 'admin/routes'

export function Account() {
  const { accountId: paramsAccountId } = useParams()

  const accountId = paramsAccountId ? paramsAccountId : 'new'

  const account = useApiQuery(
    useCallback(
      api => {
        if (accountId === 'new') {
          return [{}, null, null]
        }
        return api.getAccount(accountId)
      },
      [accountId]
    )
  )

  const pageNames = GetPageNames(accountId)

  return (
    <Layout
      header={
        <Breadcrumb
          items={[
            {
              title: (
                <BreadcrumbArrayItem href={ROUTES.ACCOUNTS.LIST}>
                  Account
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem>
                  {pageNames.data && pageNames.data.accountName}
                </BreadcrumbArrayItem>
              )
            }
          ]}
        />
      }
    >
      {!account.loaded && <ScreenSpin />}

      {account.loaded && (
        <EditSection>
          <EditAccount
            account={account.data}
            isNew={accountId === 'new'}
            accountId={accountId}
          />
        </EditSection>
      )}
    </Layout>
  )
}

const EditSection = styled.div`
  margin: auto;
  width: 30rem;
`
